import { HttpBackend } from "@angular/common/http";
import { MultiTranslateHttpLoader } from "ngx-translate-multi-http-loader";
import { TranslateLoader, TranslateService } from '@ngx-translate/core';
import {LocaleService} from '../services/locale.service';

export function createTranslateLoader(http: HttpBackend) {
    return new MultiTranslateHttpLoader(http, [
      { prefix: "./assets/i18n/login/", suffix: ".json" },
      { prefix: "./assets/i18n/userprofile/", suffix: ".json" },
      { prefix: "./assets/i18n/feedback/", suffix: ".json" },
      { prefix: "./assets/i18n/registration/", suffix: ".json" },
      { prefix: "./assets/i18n/products/", suffix: ".json" },
      { prefix: "./assets/i18n/homepage/", suffix: ".json" },
      { prefix: "./assets/i18n/general/", suffix: ".json" },
      { prefix: "./assets/i18n/promotions/", suffix: ".json" },
      { prefix: "./assets/i18n/training/", suffix: ".json" },
      { prefix: "./assets/i18n/communications/", suffix: ".json" },
      { prefix: "./assets/i18n/navigation/", suffix: ".json" },
      { prefix: "./assets/i18n/healthfair/", suffix: ".json" },
      { prefix: "./assets/i18n/reports/", suffix: ".json" },
      { prefix: "./assets/i18n/privacyandterms/", suffix: ".json" },
      { prefix: "./assets/i18n/changeAccount/", suffix: ".json" },
      { prefix: "./assets/i18n/customercontactus/", suffix: ".json" },
      { prefix: "./assets/i18n/partnercontactus/", suffix: ".json" },
      { prefix: "./assets/i18n/users/", suffix: ".json" },
      { prefix: "./assets/i18n/salesAccounts/", suffix: ".json" },
      { prefix: "./assets/i18n/account/", suffix: ".json" },
      { prefix: "./assets/i18n/feedback/", suffix: ".json" },
      { prefix: "./assets/i18n/events/", suffix: ".json" },
    ]);
  }

export const provideTranslation: () => {
  loader: {
    provide: typeof TranslateLoader;
    useFactory: (http: HttpBackend) => MultiTranslateHttpLoader;
    deps: [typeof HttpBackend];
  };
} = () => ({
  loader: {
    provide: TranslateLoader,
    useFactory: createTranslateLoader,
    deps: [HttpBackend],
  },
});


export function initializeTranslation(
  translateService: TranslateService,
  localeService: LocaleService
) {
  return async () => {
    translateService.use(localeService.getLocaleStrForTranslations());
  };
}



